import React from "react";

// components
import Bio from "../Bio";

// assets
import bioImg from "../../../assets/images/StratCap-ScottCorkery.jpg";

const ScottCBio = (props) => {
  const bioData = {
    title: "Scott Corkery",
    title2: "Chief Financial Officer",
    hashName: "scott-corkery",
    bio1: `Scott Corkery serves as Chief Financial Officer of the advisor and our sponsor. He is an integral
    part of our sponsor’s executive leadership and is instrumental in supporting the company’s
    digital infrastructure investment teams. Mr. Corkery plays a critical role in managing the
    company’s current, past and future financial obligations, providing accurate and timely financial
    reporting, and determining the appropriate mix of debt and equity across investment portfolios
    currently under management. Mr. Corkery’s background includes extensive experience in the
    hedge fund, private equity, and real estate accounting space.`,
    bio2: ` Prior to joining our sponsor, he
    was Managing Director and Head of Private Equity and Real Estate Accounting for Sculptor
    Capital. Prior to Sculptor, he was an Assistant Controller at York Capital Management. He was
    also a VP/Assistant Manager on the GSAS Toronto team at Goldman Sachs. Mr. Corkery holds a Bachelor of Science in Biology
    from Dalhousie University and a Bachelor of Commerce from Saint Mary’s University. He is also a Chartered Accountant and
    Chartered Professional Accountant with the Institute of Chartered Accountants of Nova Scotia, Canada.`,
    bio3: ``,
  };
  return (
    <Bio
      srcImg={bioImg}
      title1={bioData.title}
      title2={bioData.title2}
      hashName={bioData.hashName}
      bio1={bioData.bio1}
      bio2={bioData.bio2}
      bio3={bioData.bio3}
      closeBio={props.closeBio}
    />
  );
};

export default ScottCBio;
